/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

var target_image;

Shopify.Products = (function () {

  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;
    },
    destroy: function () {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function () {
    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try { config.onComplete() } catch (error) { }
    }
  };

  var moveAlong = function () {
    if (productHandleQueue.length && shown < config.howManyToShow) {


      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function (product) {
          // HTML追加
          // -------------------------------------
          // console.log(product);

          var url,image,title,price,variants, colors;
          var id = product.id;
          url = product.url;
          image = product.featured_image;
          title = product.title;
          price = product.price;
          variants = product.variants;
          var variant_images = '';


          // 商品タグによる条件分岐
          var price_display;
          var tax_display = "";
          if (product.tags.includes('カテゴリ_オーダーカーテン')) {
            price_display = "詳細はこちら";
          } else {
            price_display = `¥${(price / 100).toLocaleString()}`;
            tax_display = '<span class="c-products-slider__slide-price2">（税込）</span>';
          }



          if(variants.length > 1){
            $.ajax({
              url: 'https://j3w0zz2qk6.execute-api.us-east-1.amazonaws.com/default/enenShopifyMetafields',
              method: 'POST',
              crossDomain: true,
              contentType: "application/json",
              data: JSON.stringify({
                productId: id
              }),
              success: function(result) {
                colors = '<ul class="c-products-slider__slide-colors">';
                // console.log(JSON.parse(result.body));
                const data = JSON.parse(result.body);
                // console.log(data.variantMetafields);
                if(data.variantMetafields != null && data.variantMetafields.length > 0){
                    var count = 0;
                    var metafields = data.variantMetafields;
                    for(var i =0; i < metafields.length; i++){
                      // console.log(metafields[i]);
                      var imagedata = metafields[i];
                      colors += `<li class="c-products-slider__slide-color js-variantcolor" data-target="${count}">
                      <img src="${imagedata.imagesrc}" class="c-products-variation__color-img" loading="lazy" />
                    </li>`;
                    count++;
                    }
                  }
                  colors += '</ul>';
                  // console.log(colors);
                  $(`#recentlyItem-${id}`).append(colors);

                  $('.js-variantcolor').mouseover(
                  function(){
                      color_target= $(this).attr('data-target');

                      // console.log($(this).closest('.card').find('[ ="'+ color_target +'"]'))

                      if($(this).closest('.card').length > 0){
                        target_image = $(this).closest('.card').find('[data-variantorder="'+ color_target +'"]');

                      }else{

                        target_image = $(this).parent().parent().find('[data-variantorder="'+ color_target +'"]');
                      }

                      target_image.show();
                      target_image.addClass('is-show');
                      // console.log({color_target});
                      // console.log(target_image);
                  }).mouseout(function(){
                    target_image.hide();
                      target_image.removeClass('is-show');
                    });
              },
              error: function(error) {
                console.log(error);
              }
            });

          }


          if (variant_images === '') {
            // バリエーション画像がないときは商品画像を使う
            if (image && image !== '') {
              variant_images = `<img src="${image}" alt="${title}" class="variantimg" data-variantorder="0">`;
            } else {
              variant_images = `<img src="/path/to/fallback.jpg" alt="画像なし" class="variantimg">`; // フォールバック画像
            }
          }
          

          //if(variants != null && variants.length > 1){
          //  for(var i = 0; i< variants.length; i++){
          //    if(variants[i].featured_image && variants[i].featured_image.src != '' ){
          //      var image_src = variants[i].featured_image.src;
          //      variant_images += `<img src="${image_src}" alt="" class="variantimg" data-variantorder="${i}">`;
          //    }
          //  }
          //}




          var price_html = '';
          if (
            product.tags.includes('カテゴリ_オーダーカーテン') ||
            product.tags.includes('カテゴリ_オーダーシェルフ')
          ) {
            price_html = `<span class="price-item price-item--regular">詳細はこちら</span>`;
          } else {
            price_html = `
              <span class="price-item price-item--regular">¥${(variants[0].price / 100).toLocaleString()}</span>
              <span class="price__tax">税込</span>
            `;
          }
          




          var html = `
          <div class="swiper-slide c-products-slider__slide">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
    <div class="card card--standard card--media " style="--ratio-percent: 100%;">
      <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;"><div class="card__media">
            <a href="${url}">
            <div class="media media--transparentt">
              ${variant_images}
              </div>
            </a>

          </div><div class="card__content" plerdy-tracking-id="10842944601">
          <div class="card__information">
            <h3 class="card__heading" plerdy-tracking-id="91942855101">
              <a href="${url}" id="StandardCardNoMediaLink--8194439315745" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink--8194439315745 NoMediaStandardBadge--8194439315745" plerdy-tracking-id="24067138101">
                ${title}
              </a>
            </h3>
          </div>
          <div class="card__badge bottom left"></div>
        </div>
      </div>
      <div class="card__content">
        <div class="card__information">
          <h3 class="card__heading h5" id="title--8194439315745" plerdy-tracking-id="38989651201">
            <a href="${url}" id="CardLink--8194439315745" class="full-unstyled-link" aria-labelledby="CardLink--8194439315745 Badge--8194439315745" plerdy-tracking-id="72935506101">
              ${title}
            </a>
          </h3>
          <div class="card-information"><span class="caption-large light"></span>



<div class="price ">
    <a href="${url}" class="recent_price">
        <div class="price__container">
        
          <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">通常価格</span>
              ${price_html}
          </div>
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">通常価格</span>
            <span>
            <s class="price-item price-item--regular">



            </s>
            </span><span class="visually-hidden visually-hidden--inline">セール価格</span>
            <span class="price-item price-item--sale price-item--last">
              ¥${(variants[0].price / 100).toLocaleString()}
            </span>
          </div>
            <small class="unit-price caption hidden">
              <span class="visually-hidden">単価</span>
              <span class="price-item price-item--last">
                <span></span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;あたり&nbsp;</span>
                <span>
                </span>
              </span>
            </small>
         </div>
    </a>
  </div>
  <div class="LeeepReviewScoreMarker" data-product-id="${id}"></div>

</div>
        </div>




        <div class="card__badge bottom left"></div>
      </div>
    </div>
  </div>

          </div>
          `;
          jQuery(wrapper).append(html);
          // template.tmpl(product).appendTo(wrapper);
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function () {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      });
    }
    else {
      finalize();
    }

  };

  return {

    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
      } else {
        return null;
      }
    },

    showRecentlyViewed: function (params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      // Template and element where to insert.
      template = jQuery('#' + config.templateId);
      wrapper = jQuery('#' + config.wrapperId);

      // How many products to show.
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && template.length && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      }

    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {

        // What is the product handle on this page.
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        // In what position is that product in memory.
        var position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        }
        else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }

    }

  };

})();
